export function checkIfArraysContainSameValues(arrayOne, arrayTwo) {
  const arrayOneLength = arrayOne.length;
  const arrayTwoLength = arrayTwo.length;

  if (arrayOneLength !== arrayTwoLength) return false;     

  const arrayOneMatchesLength = arrayOne.filter( element => arrayTwo.includes(element)).length;
  const arrayTwoMatchesLength = arrayTwo.filter( element => arrayOne.includes(element)).length;

  return new Set([arrayOneLength, arrayTwoLength, arrayOneMatchesLength, arrayTwoMatchesLength ]).size === 1 ? true : false;
}

export function calculateGddAccumulations(gdds) {
  const accumulations = [];
  let sum = 0;
  gdds.forEach(([date, gdd]) => {
    sum += gdd;
    accumulations.push(sum);
  });
  return accumulations;
}

export function splitIntoYears(acisData, startMMDD='01-01', endMMDD='12-31') {
  const yearsOfData = [];
  let idxStart = null;
  let idxEnd = null;
  for (let i = 0; i < acisData.length; i++) {
    const dateMMDD = acisData[i][0].slice(5);
    if (dateMMDD === startMMDD) {
      idxStart = i;
    }
    if (dateMMDD === endMMDD) {
      idxEnd = i;
      if (idxStart !== null && idxStart <= idxEnd) {
        yearsOfData.push(acisData.slice(idxStart, idxEnd + 1));
      }
    }
  }
  if (idxStart !== null && (idxEnd === null || idxEnd < idxStart)) {
    yearsOfData.push(acisData.slice(idxStart));
  }
  return yearsOfData;
};